<ng-container
  *ngIf="{
    showFollowOption: showFollowOption$ | async,
    currentUserID: currentUserID$ | async,
    followingTabID: followModeService.followingTabID$ | async,
    followingBorderColor: followingBorderColor$ | async
  } as viewModel"
>
  <div class="board-user-photos" id="board-user-photos" *ngIf="users">
    <ng-container *ngFor="let user of shownUsers; let i = index; trackBy: trackByUserTabHash">
      <app-profile-photo
        [class.clickable]="viewModel.showFollowOption && viewModel.currentUserID !== user._id"
        [user]="user"
        [width]="avatarWidth"
        [fontSize]="avatarFontSize"
        class="board-user-photo"
        [isClickEnabled]="false"
        [appTooltip]="profileTooltip"
        [autoPositionArrow]="true"
        [showAnimatedImageBorder]="
          viewModel.showFollowOption && viewModel.followingTabID === user.uniqueHash
        "
        [enableImageBorder]="viewModel.followingTabID !== user.uniqueHash"
        [style.--animated-border-color]="viewModel.followingBorderColor"
        (click)="
          toggleFollow(
            viewModel.showFollowOption && viewModel.currentUserID !== user._id,
            user._id,
            user.uniqueHash
          )
        "
      >
      </app-profile-photo>
      <ng-template #profileTooltip>
        <app-tooltip [text]="user.name" [arrow]="'bottom'"></app-tooltip>
      </ng-template>
    </ng-container>
    <div *ngIf="otherUsers.length">
      <span
        [ngStyle]="{ 'z-index': maxUsers + 1 }"
        class="board-user-photo profile-icon"
        [style.width]="othersIconWidth"
        [style.height]="othersIconHeight"
        [appTooltip]="otherTooltip"
        [appTooltipStayWhenTooltipHover]="true"
        [appTooltipStayWhenTooltipHoverDelay]="0"
        [appTooltipIntersectionChangeEnabled]="false"
      >
        &nbsp;+{{ otherUsers.length }}
      </span>
    </div>
    <ng-template #otherTooltip>
      <div class="tip-container">
        <div class="tip">
          <ng-container *ngFor="let user of otherUsers; let i = index; trackBy: trackByUserTabHash">
            <div
              class="user-row"
              [class.clickable]="viewModel.showFollowOption && viewModel.currentUserID !== user._id"
              (click)="
                toggleFollow(
                  viewModel.showFollowOption && viewModel.currentUserID !== user._id,
                  user._id,
                  user.uniqueHash
                )
              "
            >
              <app-profile-photo
                [user]="user"
                [width]="20"
                [isClickEnabled]="false"
                style="margin-right: 10px"
                [showAnimatedImageBorder]="
                  viewModel.showFollowOption && viewModel.followingTabID === user.uniqueHash
                "
                [enableImageBorder]="viewModel.followingTabID !== user.uniqueHash"
                [style.--animated-border-color]="viewModel.followingBorderColor"
              >
              </app-profile-photo>
              <span class="tip-text">
                {{ user.name }}
                <span *ngIf="user.multipleTabsText">
                  {{ user.multipleTabsText }}
                </span>
              </span>
            </div>
          </ng-container>
        </div>
        <div class="tip-after"></div>
      </div>
    </ng-template>
  </div>
  <div
    class="other-users-tooltip"
    *ngIf="useShowOthersListV2 && showOthersTooltip"
    (mouseleave)="handleTooltipMouseout($event)"
  >
    <div
      class="tooltip-before"
      [style.left]="
        calculateBoardUsersPhotosWidth() !== 0
          ? calculateBoardUsersPhotosWidth() - 22 + 'px'
          : 20 + '%'
      "
    ></div>
    <div class="tooltip-content">
      <ng-container *ngFor="let user of otherUsers">
        <app-profile-photo
          [user]="user"
          [width]="26"
          [fontSize]="14"
          [isClickEnabled]="false"
          [showName]="true"
        >
        </app-profile-photo>
      </ng-container>
    </div>
  </div>
</ng-container>
